import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import { formatAmount } from '@/lib/utils/formatters'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display } from '../../utils/configuredReportFormatters'

export function lossRatioColumns(
  premiumLabel: string,
  premiumKey: string,
): ReportDataTableColumn<ConfiguredReportReportRow, string>[] {
  return [
    {
      id: 'name',
      label: 'Company / Property',
      sortKey: 'company_name',
      render: (row) => display(row.company_name ?? row.property_name),
    },
    {
      id: 'contracts_count',
      label: 'Contracts Count',
      sortKey: 'contract_count',
      render: (row) => display(row.contract_count ?? row.contracts_count),
    },
    {
      id: 'claims_count',
      label: 'Reimbursements Count',
      sortKey: 'default_count',
      render: (row) =>
        display(
          row.default_count ?? row.claims_count ?? row.reimbursements_count,
        ),
    },
    {
      id: premiumKey,
      label: premiumLabel,
      sortKey: premiumKey,
      render: (row) =>
        formatAmount(
          (row[premiumKey] ?? row.contract_revenue) as string | number,
        ),
    },
    {
      id: 'incurred_claims',
      label: 'Incurred Reimbursements',
      sortKey: 'incurred_claim_amount',
      render: (row) =>
        formatAmount(
          (row.incurred_claim_amount ??
            row.incurred_claims ??
            row.incurred_reimbursements_amount) as string | number,
        ),
    },
    {
      id: 'loss_ratio',
      label: 'Loss Ratio',
      sortKey: 'loss_ratio',
      render: (row) =>
        row.loss_ratio == null || row.loss_ratio === ''
          ? '—'
          : `${Number(row.loss_ratio).toFixed(2)}%`,
    },
    {
      id: 'profitability',
      label: 'Profitability',
      sortKey: 'profitability',
      render: (row) => display(row.profitability),
    },
  ]
}
